import { reactive, toRefs, onMounted, watch, nextTick, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getPreviewDetailBySpuId, getShopSkuListByGsCode, getShopDealerListBySku } from '@/api/directSales'
import { setSession, getSession } from '@/util'
import { showToast } from '@/util/couponCollection'
import _ from 'lodash'

export default function useShopDetail() {
  const store = useStore()
  const popUpRef = ref()
  const router = useRouter()
  const state = reactive({
    hasDealer: false,
    slideList: [],
    dblclickImage: [],
    detailData: {},
    currentSkuLis: [],
    allSkuLis: [],
    isEnterShoppingCar: true,
    isEnable: false, //计划是否生效中--true
    applyDealerParam: {},
    selectShopVariantItem: {},
    skuItem: {},
    isChecking: false
  })
  // 获取详情信息
  const getShopDetailFn = async params => {
    if (!params.spuId) return
    store.commit('SETSPUID', params.spuId)
    let data = await getPreviewDetailBySpuId(params)
    // data.salesAttributes = [
    //   {
    //     code: 'serviceContent',
    //     name: '服务内容',
    //     values: [
    //       { lable: '2A', code: '2A' },
    //       { lable: '4A', code: '4A' },
    //       { lable: '6A', code: '6A' }
    //     ]
    //   },
    //   {
    //     code: 'oilType',
    //     name: '机油类型',
    //     values: [
    //       { lable: 'AMG机油', code: 'AMG' },
    //       { lable: '普通机油', code: 'MB' }
    //     ]
    //   }
    // ]
    state.detailData = data
    // state.isEnterShoppingCar = !!data.cartEnableStatusFlag
    state.isEnable = true
    state.slideList = data.banners
    state.dblclickImage = data.banners
    state.allSkuLis = data.skuList
    state.currentSkuLis = data.skuList
    let selectShopVariantItem = {}
    if (data?.uploadSkuCount === 1 && data.skuList?.length === 1) {
      for (let index = 0; index < data.salesAttributes.length; index++) {
        const item = data.salesAttributes[index]
        selectShopVariantItem[item.code] = { code: item.values[0].code, lable: item.values[0].lable, pName: item.name, pid: item.code }
      }
      // store.commit('SETSkUITEM', { ...data.skuList[0] })
    } else {
      for (let index = 0; index < data.salesAttributes.length; index++) {
        const item = data.salesAttributes[index]
        selectShopVariantItem[item.code] = ''
      }
    }

    store.commit('SETSELECTSHOPVARIANTITEM', { ...selectShopVariantItem })
  }

  const salesAttributesTxt = computed(() => {
    let skuCount = state.detailData?.uploadSkuCount
    let salesAttributes = state.detailData?.salesAttributes || []
    let comstomerAttributesName = salesAttributes
      .map(({ name, code }) => {
        let item = store.state.selectShopVariantItem[code]
        return item && item.pName ? `${item.pName}:${item.lable}` : name
      })
      .join('; ')
    return skuCount === 1 ? false : comstomerAttributesName
  })

  const shopInfoDatas = computed(() => ({
    ...state.detailData,
    isShowStep: state.isEnable,
    max: state.max,
    currentSkuLis: state.currentSkuLis,
    isChecking: state.isChecking
  }))

  const refreshPrice = async v => {
    console.log('refreshPrice-preView')
    state.currentSkuLis = state.allSkuLis
  }
  watch(
    () => store.state.loyaltyDealerInfo,
    async v => {
      // console.log('store.state.loyaltyDealerInfo', v)
      refreshPrice(v)
    },
    { deep: true, immediate: true }
  )
  watch(
    () => store.state.selectShopVariantItem,
    v => {
      //确认skuId,更新详情图片和描述
      // {"serviceContent": { "lable": "6A", "code": "6A" },
      //   "oilType": { "lable": "AMG机油", "code": "AMG" }
      // }
      // console.log('selectShopVariantItem---watch', v)
      const keys = Object.keys(v)

      state.selectShopVariantItem = v
      if (keys && keys.length && keys.length === state.detailData?.salesAttributes?.length) {
        const skuItem = state.currentSkuLis.find(sku => keys.map(attr => sku[attr] === v[attr]['code']).every(item => item === true)) || {}
        store.commit('SETSkUITEM', { ...skuItem, max: 0 })
        // console.log('selectShopVariantItem---watch---skuItem', skuItem)
      }
    },
    { deep: true }
  )
  watch(
    () => store.state.skuItem,
    _.debounce((skuItem, old) => {
      // skuItem => {
      // console.log('store.state.skuItem-watch---------', skuItem)
      // {
      //   skuId: '1544943930118098945',
      //   serviceContent: '4A',
      //   oilType: 'AMG',
      //   price: 2 //价格
      // },
      // {"serviceContent": { "lable": "6A", "code": "6A" },
      //   "oilType": { "lable": "AMG机油", "code": "AMG" }
      // }
      if (state.allSkuLis && state.allSkuLis.length) {
        const baseItem = state.allSkuLis.find(item => item.skuId === skuItem.skuId) || {}
        state.skuItem = { ...baseItem, ...skuItem }
        store.commit('SETSTEPPEROPTION', {
          ...store.state.stepperOption,
          max: 0
        })
        let cartFlag = skuItem?.cartFlag || baseItem?.cartFlag
        state.isEnterShoppingCar = cartFlag ? !!(cartFlag === 'Y') : true
      }
      // },
    }, 300),
    { deep: true }
  )

  onMounted(async () => {})

  return {
    ...toRefs(state),
    getShopDetailFn,
    salesAttributesTxt,
    shopInfoDatas
  }
}
